<ul class="card-list">
  <li class="card-list__item" *ngFor="let card of cards; trackBy: trackBy">
    <lib-list-card [data]="card.data"></lib-list-card>
    <!--    <app-card-outlet [card]="card"></app-card-outlet>-->
  </li>
</ul>
